import React, { Component } from 'react';
import { Divider, Dropdown, DropdownItemProps, DropdownProps, Grid, Header, Icon, Input, InputOnChangeData, Modal, Pagination, PaginationProps } from 'semantic-ui-react';
import { strings } from '../..';
import { Anagrafica, Column, DataTable } from '../../core';
import { datetimeFormatter } from '../../core/utility';
import { Ordine, StatoOrdine } from '../models';
import { allStatiValues } from '../utility';
import { materialiFormatter, numeroDocumentoFormatterComputer, numeroDocumentoFormatterMobile, statoOrdineFormatter } from './Formatters';
import parse from 'html-react-parser';

type ElencoOrdiniMobileProps = {
    ordini: ReadonlyArray<Ordine>,
    page: number,
    pageSize: number,
    itemsCount: number,
    anagrafica: Anagrafica,
    isTablet: boolean,
    loadOrdini: (search: string, page: number, stato?: StatoOrdine) => void
}

type ElencoOrdiniMobileState = {
    search: string,
    stato?: StatoOrdine
}

export default class ElencoOrdiniMobile extends Component<ElencoOrdiniMobileProps, ElencoOrdiniMobileState> {
    constructor(props: ElencoOrdiniMobileProps) {
        super(props);

        this.state = {
            search: ''
        };
    }

    componentDidMount() {
        this.onSearch(this.props.page);
    }

    render() {
        const optionsStati: DropdownItemProps[] = allStatiValues.map(stato => ({
            key: stato.stato,
            value: stato.stato, 
            text: stato.text, 
            content: <><Icon name={stato.name} color={stato.color} /> {stato.text}</>
        }))

        return (
            <Grid centered>
                <Grid.Row centered>
                    <Header as='h2' textAlign='center'>
                        <Icon name='zip' />
                        <Header.Content>
                            {strings.ordini.elenco.titolo}
                            <Header.Subheader>{this.props.anagrafica.ragioneSociale}</Header.Subheader>
                        </Header.Content>
                    </Header>
                </Grid.Row>
                <Grid.Row>
                    <Grid.Column tablet='11' mobile='9'>
                        <Input
                            fluid
                            icon={<Icon onClick={this.onSearchClick} name="search" inverted circular link />}
                            placeholder={strings.core.azioni.ricerca}
                            value={this.state.search}
                            onChange={this.onSearchChange}
                        />
                    </Grid.Column>
                    <Grid.Column tablet='4' mobile='7'>
                        <Dropdown selection clearable fluid options={optionsStati} onChange={this.onStatoChange} />
                    </Grid.Column>
                </Grid.Row>
                {this.props.isTablet && this.renderTablet()}
                {!this.props.isTablet && this.renderMobile()}
            </Grid>
        );
    }

    renderTablet = () => {
        const { ordini, itemsCount, page, pageSize } = this.props;
        const columns: Column<Ordine>[] = [
            { key: 'numero', label: strings.ordini.elenco.dataTable.numero, width: '2', textAlign: 'right', formatter: numeroDocumentoFormatterComputer },
            { key: 'data', label: strings.ordini.elenco.dataTable.data, width: '2', formatter: datetimeFormatter },
            { key: 'codice', label: strings.ordini.elenco.dataTable.matricola },
            { key: 'descrizione', label: strings.ordini.elenco.dataTable.modello },
            { key: 'numeroMacchina', label: strings.ordini.elenco.dataTable.numMacchina, width: '2' },
            { key: 'stato', label: strings.ordini.elenco.dataTable.stato, width: '2', formatter: statoOrdineFormatter },
            { key: 'idOrdine', label: '', width: '1', textAlign: 'center', formatter: this.materialiModalFormatter }];

        return (
            <Grid.Row>
                <Grid.Column width='15'>
                    <DataTable<Ordine> 
                        dataSource={ordini} 
                        primaryKey='idOrdine' 
                        columns={columns} 
                        page={page}
                        pageSize={pageSize}
                        itemsCount={itemsCount}
                        onPageChanged={this.onPageChanged} />
                </Grid.Column>
            </Grid.Row>
        )
    }

    renderMobile = () => (
        <>
            {this.props.ordini.map(this.renderOrdineMobile)}
            {this.renderPaginazione()}
        </>
    )
    
    renderPaginazione = () => {        
        const { itemsCount, page, pageSize } = this.props;
        const pageCount = Math.ceil(itemsCount / pageSize);

        return (
            <Grid.Row>
                <Pagination 
                    activePage={page}
                    totalPages={pageCount}
                    onPageChange={this.onPageChangedMobile}
                    firstItem={null}
                    lastItem={null}
                />
            </Grid.Row>
        );
    }

    renderOrdineMobile = (ordine: Ordine) => {
        return (
            <React.Fragment key={ordine.idOrdine}>
                <Grid.Row>
                    <Grid.Column width='14'>
                        <Grid>
                            <Grid.Row style={{ height: 30 }}>
                                <Grid.Column width='5'><b>{datetimeFormatter(ordine.data)}</b></Grid.Column>
                                <Grid.Column width='5'>{numeroDocumentoFormatterMobile(ordine.numero)}</Grid.Column>
                                <Grid.Column width='6'>{statoOrdineFormatter(ordine.stato)}</Grid.Column>
                            </Grid.Row>
                            <Grid.Row style={{ height: 30 }}>
                                <Grid.Column width='3'><b>{ordine.numeroMacchina}</b></Grid.Column>
                                <Grid.Column width='6'>{ordine.codice}</Grid.Column>
                                <Grid.Column width='7' textAlign='right'>{ordine.descrizione}</Grid.Column>
                            </Grid.Row>
                            {
                                ordine.ubicazione !== "" &&
                                <Grid.Row style={{ padding: 3 }}>
                                    <Grid.Column width='2'><Icon color='green' name='map marker alternate'/></Grid.Column>
                                    <Grid.Column width='14' verticalAlign='middle'> {parse(ordine.ubicazione)}</Grid.Column>
                                </Grid.Row>
                            }
                        </Grid>
                    </Grid.Column>
                    <Grid.Column width='2'>
                        {this.materialiModalFormatter(1, ordine)}
                    </Grid.Column>
                </Grid.Row>
                <Divider fitted />
            </React.Fragment >
        );
    }

    materialiModalFormatter = (_: any, item: Ordine) => (
        <Modal trigger={<Icon name='tasks' bordered />} size='mini' closeIcon>
            <Header icon='zip' content={strings.ordini.elenco.dataTable.materiali} />
            <Modal.Content>
                {materialiFormatter(_, item)}
                <Divider />
                <b>{strings.ordini.elenco.dataTable.utente}:</b> {item.userName}
                {item.stato === StatoOrdine.Rifiutato &&
                    <><br /><b>{strings.ordini.elenco.dataTable.motivoRifiuto}:</b> {item.motivoRifiuto}</>}
            </Modal.Content>
        </Modal>
    )

    onSearchChange = (_: React.ChangeEvent<HTMLInputElement>, data: InputOnChangeData) => {
        this.setState({ search: data.value });
    }

    onPageChanged = (page: number) => {
        this.onSearch(page);
    }

    onPageChangedMobile = (_: React.MouseEvent<HTMLAnchorElement>, data: PaginationProps) => {
        const page = Number(data.activePage);
        this.onSearch(page);
    }

    onStatoChange = (_: React.SyntheticEvent<HTMLElement, Event>, data: DropdownProps) => {
        const stato: StatoOrdine | undefined = data.value === '' ? undefined : data.value as StatoOrdine;
        this.setState({ stato: stato }, () => this.onSearch(this.props.page));
    }

    onSearchClick = () => {
        this.onSearch(this.props.page);
    }

    onSearch = (page: number) => {
        const { search, stato } = this.state;
        this.props.loadOrdini(search, page, stato);
    }
}
